<template>
  <div
      class="relative bg-[#F8F8F8] rounded-lg border border-[#E6E6E6] h-[120px] p-4"
  >
    <div
        class="absolute top-2.5 inset-x-0 mx-auto h-[32px] w-[32px] rounded-full shadow-[#9770D6]"
        style="box-shadow: rgb(193 169 233) 0px 0px 17px"
    ></div>

    <flicking
        :options="{
        circular: false,
        moveType: 'snap',
        horizontal: true,
        defaultIndex: index,
      }"
        @changed="change"
    >
      <div v-for="item in data" :key="item" class="text-center w-12">
        {{ item }}
      </div>
    </flicking>

    <svg
        class="mx-auto my-[16px]"
        fill="none"
        height="18"
        viewBox="0 0 14 18"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path
          d="M6.05509 0.727723C6.36578 -0.169174 7.63422 -0.169174 7.94491 0.727724L13.4684 16.6727C13.6934 17.3223 13.211 18 12.5235 18H1.47651C0.789011 18 0.30656 17.3223 0.531596 16.6727L6.05509 0.727723Z"
          fill="#8050CD"
      />
    </svg>
    <div class="text-center font-[400] text-[12px] text-[#555555]">
      {{ label }}
    </div>
  </div>
</template>

<script>
import {Flicking} from "@egjs/vue-flicking";

export default {
  props: {
    label: {
      type: String,
      required: true,
    },

    data: {
      type: Array,
      required: true,
    },

    value: {
      type: [String, Number],
      required: true,
    },
  },

  components: {Flicking},

  computed: {
    index() {
      return this.data.indexOf(this.value);
    },
  },

  methods: {
    change({currentTarget}) {
      this.$emit("input", this.data[currentTarget.index]);
    },
  },
};
</script>

<style>
.flicking-viewport {
  direction: ltr !important;

  @apply overflow-hidden relative;
}

.flicking-camera {
  @apply flex relative w-full h-full cursor-grab;
}

.flicking-camera div:active {
  @apply cursor-grabbing;
}

.flicking-camera > * {
  @apply flex-shrink-0;
}
</style>